import { UPDATE_FINAL_ORDER_RESPONSE, SAVE_VIRTUAL_ACCOUNT } from "../../actions/constants";

const initialOrderState = {
  orderDetails: {},
  finalOrderResponse: null,
  virtualAccount: null,
};

export const orderDetailsReducer = (state = initialOrderState, action) => {
  switch (action.type) {
    case "SAVE_ORDER_DETAILS": {
      return {
        ...state,
        orderDetails: { ...action.orderDetails },
      };
    }
    case UPDATE_FINAL_ORDER_RESPONSE: {
      return {
        ...state,
        finalOrderResponse: action?.payload,
      };
    }
    case SAVE_VIRTUAL_ACCOUNT: {
      return {
        ...state,
        virtualAccount: action?.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default orderDetailsReducer;
